import {
  IonBadge,
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonText,
  useIonToast,
} from "@ionic/react";
import { add } from "ionicons/icons";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Header from "src/components/Header";
import {
  Cita,
  colorEstado,
  etiquetaEstado,
  listarMisCitas,
} from "src/services/atencionCliente";

type Filtro = "proximas" | "pasadas" | "canceladas";

const ESTADOS_PROXIMOS: Record<string, true> = {
  AGENDADA: true,
  EN_ESPERA: true,
  EN_ATENCION: true,
  PAUSADA: true,
};
const ESTADOS_CANCELADOS: Record<string, true> = {
  CANCELADA: true,
  CANCELADA_NO_SHOW: true,
  CANCELADA_REAGENDADA: true,
};

const AtcMisCitas: React.FC = () => {
  const history = useHistory();
  const [present] = useIonToast();
  const [citas, setCitas] = useState<Cita[]>([]);
  const [filtro, setFiltro] = useState<Filtro>("proximas");
  const [cargando, setCargando] = useState(false);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const lista = await listarMisCitas();
      setCitas(lista);
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Error al cargar";
      present({ message: msg, duration: 3000, color: "danger" });
    } finally {
      setCargando(false);
    }
  }, [present]);

  useEffect(() => {
    void cargar();
  }, [cargar]);

  const visibles = citas.filter((c) => {
    if (filtro === "proximas") return ESTADOS_PROXIMOS[c.estado];
    if (filtro === "pasadas") return c.estado === "TERMINADA";
    if (filtro === "canceladas") return ESTADOS_CANCELADOS[c.estado];
    return true;
  });

  return (
    <IonPage>
      <Header titulo="Mis citas" />
      <IonContent>
        <IonSegment
          value={filtro}
          onIonChange={(e) => setFiltro((e.detail.value as Filtro) || "proximas")}
        >
          <IonSegmentButton value="proximas">
            <IonLabel>Proximas</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="pasadas">
            <IonLabel>Pasadas</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="canceladas">
            <IonLabel>Canceladas</IonLabel>
          </IonSegmentButton>
        </IonSegment>

        <IonLoading isOpen={cargando} message="Cargando..." />

        {visibles.length === 0 && !cargando && (
          <IonText color="medium">
            <div style={{ padding: "2rem", textAlign: "center" }}>
              No tenes citas en esta categoria.
            </div>
          </IonText>
        )}

        <IonList>
          {visibles.map((c) => {
            const fecha = new Date(c.fecha_hora_agendada);
            return (
              <IonItem
                key={c.id}
                button
                onClick={() => history.push(`/atencion-cliente/citas/${c.id}`)}
              >
                <IonLabel>
                  <h2>{c.motivo}</h2>
                  <p>{c.dpto_destino_nombre}</p>
                  <p>
                    {fecha.toLocaleDateString("es-PY")}{" "}
                    {fecha.toLocaleTimeString("es-PY", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                </IonLabel>
                <IonBadge slot="end" color={colorEstado(c.estado)}>
                  {etiquetaEstado(c.estado)}
                </IonBadge>
              </IonItem>
            );
          })}
        </IonList>

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => history.push("/atencion-cliente/nueva")}>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default AtcMisCitas;
